Shopify.formatMoney = function(cents, format) {
    if (typeof cents == 'string') { cents = cents.replace('.',''); }
    var value = '';
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var formatString = (format || this.money_format);

    function defaultOption(opt, def) {
        return (typeof opt == 'undefined' ? def : opt);
    }

    function formatWithDelimiters(number, precision, thousands, decimal) {
        precision = defaultOption(precision, 2);
        thousands = defaultOption(thousands, ',');
        decimal   = defaultOption(decimal, '.');

        if (isNaN(number) || number == null) { return 0; }

        number = (number/100.0).toFixed(precision);

        var parts   = number.split('.'),
            dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
            cents   = parts[1] ? (decimal + parts[1]) : '';

        return dollars + cents;
    }

    switch(formatString.match(placeholderRegex)[1]) {
        case 'amount':
            value = formatWithDelimiters(cents, 2);
            break;
        case 'amount_no_decimals':
            value = formatWithDelimiters(cents, 0);
            break;
        case 'amount_with_comma_separator':
            value = formatWithDelimiters(cents, 2, '.', ',');
            break;
        case 'amount_no_decimals_with_comma_separator':
            value = formatWithDelimiters(cents, 0, '.', ',');
            break;
    }

    return formatString.replace(placeholderRegex, value);
};


function refreshCartPrices() {
    // Send an AJAX request to update the cart
    const formData = new FormData();

    fetch('/cart.js', {
        method: 'GET',
        headers: {
            'X-Requested-With': 'XMLHttpRequest',
        },
    })
        .then((response) => response.json())
        .then((data) => {

            let totalPriceElements = document.querySelectorAll('.cart-price__total');
            totalPriceElements.forEach(function(element) {
                element.innerHTML = Shopify.formatMoney(data.total_price);
            });

            data.items.forEach((item) => {
                let itemWrapper = document.querySelector(`#item-${item.id}`);
                itemWrapper.querySelector('.item-line__price').innerHTML = Shopify.formatMoney(item.line_price);
            });

        })
        .catch((error) => {
            console.error('Error updating cart:', error);
        });
}

function updateCart(itemKey, action) {
    const quantityInput = document.getElementById(`quantity-${itemKey}`);
    const newValue = parseInt(quantityInput.value) + (action === 'increment' ? 1 : -1);

    if (newValue >= 1) {
        quantityInput.value = newValue;

        // Send an AJAX request to update the cart
        const formData = new FormData();
        formData.append('id', itemKey);
        formData.append('quantity', newValue);

        fetch('/cart/change.js', {
            method: 'POST',
            body: formData,
            headers: {
                'X-Requested-With': 'XMLHttpRequest',
            },
        })
            .then((response) => response.json())
            .then((data) => {
                refreshCartPrices();
                // Handle the response data, e.g., update the cart summary or display a message.
            })
            .catch((error) => {
                console.error('Error updating cart:', error);
            });
    }
}

function deleteItem(itemKey) {
    // Send an AJAX request to remove the item from the cart
    const formData = new FormData();
    formData.append('id', itemKey);
    formData.append('quantity', 0);

    fetch('/cart/change.js', {
        method: 'POST',
        body: formData,
        headers: {
            'X-Requested-With': 'XMLHttpRequest',
        },
    })
        .then((response) => response.json())
        .then((data) => {
            let form = document.querySelector('#cart-form');
            form.querySelector(`#item-${itemKey}`).remove();
            refreshCartPrices();
            window.location = '/cart'
        })
        .catch((error) => {
            console.error('Error deleting item from cart:', error);
        });
}

// Prevent the default form submission and use AJAX instead
const cartForm = document.getElementById('cart-form');
cartForm.addEventListener('submit', function (event) {
    event.preventDefault();
    // You can handle the form submission with AJAX here if needed.
});